import React from "react";
import { Fab, Paper } from "@mui/material";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import CloseIcon from "@mui/icons-material/Close";
import { ChatPhase, useChat } from "../../context/ChatContext";
import ChatHeader from "./ChatHeader";
import ChatMessages from "./ChatMessages";
import DocumentSelectionFooter from "./DocumentSelectionFooter";
import QuestionInput from "./QuestionInput";

const HEADER_HEIGHT = 120;
const BOTTOM_OFFSET = 90;
const WINDOW_GAP = 10;

const ChatBot: React.FunctionComponent = () => {
	const {
		isChatOpen,
		phase,
		isBotTyping,
		messages,
		selectedDocuments,
		toggleChat,
		closeChat,
		removeDocumentFromSelection,
		sendQuestion,
		resetConversation,
	} = useChat();

	return (
		<>
			{isChatOpen && (
				<Paper
					sx={{
						position: "fixed",
						bottom: `${BOTTOM_OFFSET}px`,
						right: "20px",
						width: "480px",
						maxWidth: "calc(100vw - 40px)",
						height: "680px",
						maxHeight: `calc(100vh - ${
							HEADER_HEIGHT + BOTTOM_OFFSET + WINDOW_GAP
						}px)`,
						zIndex: 1300,
						display: "flex",
						flexDirection: "column",
						borderRadius: "12px !important",
						overflow: "hidden",
					}}
				>
					<ChatHeader onClose={closeChat} onReset={resetConversation} />
					<ChatMessages
						messages={messages}
						phase={phase}
						isBotTyping={isBotTyping}
					/>
					<DocumentSelectionFooter
						selectedDocuments={selectedDocuments}
						onRemoveDocument={removeDocumentFromSelection}
					/>
					<QuestionInput
						disabled={phase === ChatPhase.LOADING}
						onSend={sendQuestion}
					/>
				</Paper>
			)}

			<Fab
				color="primary"
				onClick={toggleChat}
				sx={{
					position: "fixed",
					bottom: "20px",
					right: "20px",
					zIndex: 1300,
				}}
			>
				{isChatOpen ? <CloseIcon /> : <ChatBubbleOutlineIcon />}
			</Fab>
		</>
	);
};

export default ChatBot;
